import { LocalStorageService } from 'src/app/common/services/local-storage.service';

const localStorageService = new LocalStorageService();
let typeEndosso = localStorageService.get('endosso');

export function isEndossoDisminucionPrima(): boolean {
  return typeEndosso === 'DISMINUCION_PRIMA';
}

export function isEndossoAumentoPrima(): boolean {
  return typeEndosso === 'AUMENTO_PRIMA';
}

export function isEndossoSinMovPrima(): boolean {
  return typeEndosso === 'SIN_MOV_PRIMA';
}

export function isEndosso(): boolean {
  return !!typeEndosso && typeEndosso !== 'EMIT';
}

export function isRenovation(): boolean {
  return  typeEndosso === 'EMIT';
}

export function isEndoAumentoOrDisminucionPrima(): boolean {
  return isEndossoDisminucionPrima() || isEndossoAumentoPrima();
}

export function isCancelEndosso(): boolean {
  return typeEndosso === 'CANCEL';
}
export function reloadTypeEndosso(): void {
  setTimeout(() => {
    typeEndosso = localStorageService.get('endosso');
  }, 10);
}
